import React from "react"
import styled from "styled-components"
import Icon from "../../images/whatsapp.svg"

const Link = styled.a`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-color: ${props => props.theme.mint};
  width: 3.35rem;
  height: 3.35rem;
  z-index: 100000;
  background-image: url("${Icon}");
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  border-radius: 100%;

  @media screen and (max-width: 766px) {
    right: 1rem;
    bottom: 1rem;
  }
`
const Chat = () => {
  const logEvent = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "Click", {
        event_category: "Chat Button",
        event_label: "Learn",
        value: 1,
      })
    }
  }

  return (
    <Link
      href="https://wa.me/256392177488"
      onClick={() => {
        logEvent()
      }}
      title="Chat on WhatsApp"
    ></Link>
  )
}

export default Chat
